var map = {
	"./americanexpress.png": "139e",
	"./americanexpress02.png": "afb5",
	"./cirrus.png": "2a4e",
	"./delta.png": "a222",
	"./dinersclub.png": "6419",
	"./directdebit.png": "a0a6",
	"./discover.png": "412a",
	"./egold.png": "f5b2",
	"./maestro.png": "a733",
	"./mastercard.png": "72cf",
	"./paypal.png": "c14e",
	"./solo.png": "dc26",
	"./switch.png": "60e0",
	"./visa.png": "3e2d",
	"./visa02.png": "b769",
	"./visaelectron.png": "18af",
	"./westernunion.png": "ac28",
	"./westernunion02.png": "fde6",
	"./westernunion03.png": "8991",
	"./wirecard.png": "5356",
	"./worldpay.png": "0397"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7518";